import { entityToFormValuesMapper } from "../../Common/utils";

const mapToLocaleArray = obj =>
  obj && !Array.isArray(obj)
    ? Object.entries(obj).map(([locale, t]) => ({ locale, ...t }))
    : obj ?? [];

function normalizeFieldTranslations(field) {
  if (!field.translations || Array.isArray(field.translations)) return field.translations;
  return Object.entries(field.translations).map(([locale, t]) => ({
    locale,
    label: t.label || "",
    placeholder: t.placeholder || "",
    description: t.description || "",
    items: (field.items || []).map(item => ({
      value: item.value,
      label: (item.labels && item.labels[locale]) || item.value,
    })),
  }));
}

function normalizeBmEntity(entity) {
  return {
    ...entity,
    translations: mapToLocaleArray(entity.translations),
    fields: (entity.fields || []).map(field => ({
      ...field,
      translations: normalizeFieldTranslations(field),
    })),
  };
}

function deriveRequiredFromConstraints(fields) {
  return (fields || []).map(field => ({
    ...field,
    required: field.constraints?.required === "true",
  }));
}

function extractDependers(formValues) {
  if (!Array.isArray(formValues.dependers)) return formValues;
  const depender = formValues.dependers[0];
  return {
    ...formValues,
    dependersBoxes: ((depender && depender.tickers) || []).filter(Boolean),
    dependers: (depender && depender.type) || "",
  };
}

function flattenItemLabelsForDisplay(fields) {
  return (fields || []).map(field => ({
    ...field,
    translations: field.translations?.map(translation => ({
      ...translation,
      items: (translation.items || []).map(item => item.label).join(),
    })),
  }));
}

export function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity: normalizeBmEntity(entity),
    fields,
    locales,
    translationConfig,
  });
  const withRequired = { ...formValues, fields: deriveRequiredFromConstraints(formValues.fields) };
  const withDependers = extractDependers(withRequired);
  return { ...withDependers, fields: flattenItemLabelsForDisplay(withDependers.fields) };
}

export const __test__ = {
  mapToLocaleArray,
  normalizeFieldTranslations,
  normalizeBmEntity,
  deriveRequiredFromConstraints,
  extractDependers,
  flattenItemLabelsForDisplay,
};
